import { Navigate, Outlet } from "react-router";
import { useAuth } from "../context/AuthContext";
export function ProtectedRoute() {
  const { isRestoring, isAuthenticated } = useAuth();
  if (isRestoring) return null;
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}